import { type HelpTextType } from './HelpTextConfig';

export const helpTextTypesArray: HelpTextType[] = [
  'resources',
  'main',
  'plants',
  'factories',
  'stock',
  'wood',
  'cotton',
  'bulk',
  'lumber',
  'textiles',
  'bricks',
  'paper',
  'furniture_factory',
  'garment_factory',
  'printing_factory',
];
